import { render, staticRenderFns } from "./MasterDataListPage.vue?vue&type=template&id=ed2d8f5e&scoped=true&"
import script from "./MasterDataListPage.vue?vue&type=script&lang=js&"
export * from "./MasterDataListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed2d8f5e",
  null
  
)

export default component.exports